import { ContactNumberData } from './contact-number-data';

export interface ContactData {
  sort: number;
  type: string; // Teilnehmer, Arzt, Angehöriger ...
  firstname: string;
  lastname: string;
  company: string;
  street: string;
  zip: string;
  city: string;
  contactNumbers: ContactNumberData[];
  email: string;
  info: string;
  country: string;
  appId?: string;
}

export class ContactData implements ContactData {
  sort = 1;
  type = '';
  firstname = '';
  lastname = '';
  company = '';
  street = '';
  zip = '';
  city = '';
  contactNumbers = [] as ContactNumberData[];
  email = '';
  info = '';
  country = '';
}
